import classNames from 'classnames';
import styles from './index.module.scss';

const A4Render = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      className={classNames(
        'w-[594.3pt] h-[840.51pt] bg-white py-4 px-10 flex flex-col text-black',
        styles.dempyou,
      )}
    >
      {children}
    </div>
  );
};

export default A4Render;
